export const openInNewTabWithFallback = (url: string): void => {
  const newWindow = window.open(url, '_blank');
  if (!newWindow) {
    console.warn('Popup blocked, falling back to <a> element.');
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }
};
